import {format} from '../i18n.js';
export function initResultGallery(root, { gsap, motion, scope }) {
  const document=scope.document;
  const gallery = root.querySelector("[data-result-gallery]");
  if (!gallery) return null;
  const slides = [...gallery.querySelectorAll("[data-result-slide]")];
  if (!slides.length) return null;
  const status = gallery.querySelector('[role="status"]');
  let current = 0;
  const select = (index, animate = true) => {
    gsap.killTweensOf(slides);
    gsap.set(slides, { clearProps: "all" });
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.hidden = i !== current;
    });
    const slide = slides[current];
    slide.querySelector("img").loading = "eager";
    if (status) status.textContent = format('Zdjęcie %d z %d: %s',current + 1,slides.length,slide.querySelector('img').alt);
    if (animate && motion.enabled) {
      gsap.fromTo(
        slide,
        { x: 48, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 0.6,
          ease: "power3.out",
          clearProps: "all",
        },
      );
    }
  };
  scope.on(gallery
    .querySelector("[data-gallery-prev]"), "click", () => select(current - 1));
  scope.on(gallery
    .querySelector("[data-gallery-next]"), "click", () => select(current + 1));
  scope.on(gallery, "keydown", (event) => {
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.preventDefault();
      select(current + (event.key === "ArrowRight" ? 1 : -1));
    }
  });
  const viewport = gallery.querySelector('.aw-result-gallery__viewport');
  let swipe = null;
  scope.on(viewport, 'pointerdown', (event) => {
    if (event.pointerType === 'mouse' || event.isPrimary === false) {
      swipe = null;
      return;
    }
    swipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
    viewport.setPointerCapture?.(event.pointerId);
  });
  scope.on(viewport, 'pointerup', (event) => {
    const start = swipe;
    swipe = null;
    if (!start || event.pointerId !== start.id) return;
    const dx = event.clientX - start.x, dy = event.clientY - start.y;
    if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.5) select(current + (dx < 0 ? 1 : -1));
  });
  scope.on(viewport, 'pointercancel', () => { swipe = null; });
  scope.on(viewport, 'lostpointercapture', () => { swipe = null; });
  select(0, false);
  scope.on(document, "aw:motionchange", () => {
    gsap.killTweensOf(slides);
    gsap.set(slides, { clearProps: "all" });
  });
  scope.onDispose(() => { swipe = null; gsap.killTweensOf(slides); });
  return { select };
}
